import { Box, Grid } from "@mui/material";
import React, { useContext } from "react";
import NeoButton from "../components/NeoButton";
import { useAuthStore } from "../@shared/store/useAuthStore";
import { MainContext } from "../App";
import { useTutorial } from "../@shared/utils/useTutorial";
import { finalizeTutorialOnboarding } from "../@shared/utils/tutorialCompletion";
import IOIntro from "../components/tutorialSequences/IOIntro";
import Dashboard from "./Dashboard";

const TutorialSequences = () => {
  const { Theme, setError, setInfo, setSuccess, setMessage } =
    useContext(MainContext);
  const { userData } = useAuthStore();
  const { progress, sequence } = useTutorial(userData?.id);
  const [skipping, setSkipping] = React.useState(false);

  const showSkipTutorialButton =
    progress?.currentSequence &&
    progress.currentSequence !== "dashboardTutorial";

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const setToast = (type, msg) => {
    setMessage(msg);
    if (type === "info") setInfo(true);
    else if (type === "success") setSuccess(true);
    else if (type === "error") setError(true);
  };

  const handleSkip = async ({ silent = false } = {}) => {
    if (!userData?.id) return;

    if (!silent) {
      setSkipping(true);
      setMessage("Skipping tutorial...");
      setInfo(true);
    }

    try {
      if (!silent) {
        await delay(250);
        setMessage("Finalizing your starter setup...");
        setInfo(true);
      }

      await finalizeTutorialOnboarding(userData.id);

      if (!silent) {
        setMessage("All set! Your deck is ready. Good luck, traveler!");
        setSuccess(true);
      }
    } catch (err) {
      console.error("[handleSkip] fail:", err);
      setToast(
        "error",
        "We hit a snag skipping the tutorial. Nothing was consumed. Please try again."
      );
    } finally {
      if (!silent) {
        setSkipping(false);
      }
    }
  };

  return (
    <Grid
      container
      xs={12}
      sx={{
        height: "100dvh",
        background: "black",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {skipping && (
        <Box
          sx={{
            width: "100dvw",
            height: "100dvh",
            background: "#00000080",
            position: "absolute",
            left: 0,
            top: 0,
            zIndex: 5000,
          }}
        />
      )}

      {showSkipTutorialButton && (
        <Box
          sx={{
            display:
              userData?.tutorialProgress?.currentSequence !== "introDialogue" ||
              userData?.tutorialProgress?.currentStepIndex > 2
                ? "block"
                : "none",
            position: "fixed",
            top: "2%",
            right: "2%",
            zIndex: 2147483000,
            width: "200px",
            opacity: skipping ? 0.5 : 1,
            pointerEvents: "auto",
          }}
        >
          <NeoButton
            text={!skipping ? "Skip Tutorial" : "Skipping"}
            disabled={skipping}
            onClick={handleSkip}
            color={Theme.palette.secondary.main}
            width={100}
          />
        </Box>
      )}

      {progress?.currentSequence === "introDialogue" &&
        sequence?.type === "dialogue" && <IOIntro />}

      {progress?.currentSequence === "dashboardTutorial" && (
        <Dashboard tutorialMode={true} />
      )}
    </Grid>
  );
};

export default TutorialSequences;
